import * as Yup from "yup";

export const reportFormValidation = Yup.object({
  name: Yup.string().required("Required"),
  report_sub_type: Yup.mixed().when("report_type", {
    is: "vehicle_performance",
    then: Yup.mixed().notRequired(),
    otherwise: Yup.mixed().required("Required"),
  }),
  metadata: Yup.object().shape({
    selection_criteria: Yup.string().required("Selection Criteria is Required"),
    asset_ids: Yup.array()
      .of(Yup.string().required("Asset ID is Required"))
      .min(1, "At least one Asset ID is required"),
    asset_type: Yup.string().required("Asset Type is Required"),
    custom_event_configuration_ids: Yup.array().when(["$report_type", "$event_type"], {
      is: (report_type, event_type) => report_type === "event" && event_type === "custom",
      then: Yup.array()
        .of(Yup.number())
        .min(1, "At least one custom event configuration is required"),
      otherwise: Yup.array(),
    }),
  }),
  report_configuration_id: Yup.string().when(["report_type", "report_sub_type"], {
    is: (report_type, report_sub_type) =>
      report_type === "trackpoint" && report_sub_type === "detailed",
    then: Yup.string().required("Report Configuration is Required"),
  }),
  summary_interval: Yup.mixed().when(["report_type", "report_sub_type"], {
    is: (report_type, report_sub_type) =>
      report_type !== "vehicle_performance" && report_sub_type === "summary",
    then: Yup.mixed().required("Required"),
    otherwise: Yup.mixed().notRequired(),
  }),
  event_type: Yup.mixed().when("report_type", {
    is: "event",
    then: Yup.mixed().required("Required"),
    otherwise: Yup.mixed(),
  }),
  start_time: Yup.number()
    .when("report_type", {
      is: "offline_report",
      then: Yup.number().nullable(),
    })
    .when(["report_type", "event_type"], {
      is: (report_type, event_type) => report_type === "event" && event_type === "custom",
      then: Yup.number()
        .required("Start time is required")
        .test("date-range-limit", "Date range cannot exceed 90 days", function (value) {
          const { end_time } = this.parent;
          if (!value || !end_time) return true;
          const diffInDays = (end_time - value) / 86400;
          return diffInDays <= 90;
        }),
    }),
  end_time: Yup.number()
    .when("report_type", {
      is: "offline_report",
      then: Yup.number().nullable(),
    })
    .when(["report_type", "event_type"], {
      is: (report_type, event_type) => report_type === "event" && event_type === "custom",
      then: Yup.number()
        .required("End time is required")
        .test("end-after-start", "End date must be after start date", function (value) {
          const { start_time } = this.parent;
          if (!value || !start_time) return true;
          return value > start_time;
        }),
    }),
});

export const containerFormValidation = Yup.object().shape({
  name: Yup.string().min(3, "Minimum 3 characters required").required("Required"),
  path: Yup.string().min(3, "Minimum 3 characters required").required("Required"),
  plugins: Yup.array()
    .min(1, "At least one plugin is required")
    .max(1, "Only one plugin can be added")
    .required("Required"),
});
